export default __webpack_public_path__ + "static/media/search.a733bf18.svg";